import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import courseEvasionReadAction from './courseEvasionRead.action.json'

const courseEvasionReadDefinition = defineReadAutoAction(courseEvasionReadAction, 'courseEvasion')

export default courseEvasionReadDefinition
